import React, { useEffect, useState } from "react";
import { Box, Container, Heading, VStack, SimpleGrid, Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
import { ReactComponent as Logo } from "assets/logo.svg";
//import { contentful } from "api/contentful/client";
//import { GetHelpCategoriesAndTopics } from "api/contentful/queries.gql";
import { getHelpContent } from "api/webservice/content";
import Categories from "./Categories";
import Section from "./Section";
import { BasicLayout } from "layouts";

const Help: React.FC = () => {

  const [coachHelpCategories, setCoachHelpCategories] = useState([]);
  const [clientHelpCategories, setClientHelpCategories] = useState([]);
  const [coachActiveIndex, setCoachActiveIndex] = useState(0);
  const [clientActiveIndex, setClientActiveIndex] = useState(0);
  // @ts-ignore
  const coachTopics = coachHelpCategories[coachActiveIndex]
    ? // @ts-ignore
    // have the help topic appear in both categories if it hasn't been tagged, to avoid whitescreening issue
    coachHelpCategories[coachActiveIndex].topics?.filter(item => (item.tag == null || item.tag.includes("coach")))
    : [];
  const clientTopics = clientHelpCategories[clientActiveIndex]
    ? // @ts-ignore
    // have the help topic appear in both categories if it hasn't been tagged, to avoid whitescreening issue
    clientHelpCategories[clientActiveIndex].topics?.filter(item => (item.tag == null || item.tag.includes("client")))
    : [];

  useEffect(() => {
    //contentful.query(GetHelpCategoriesAndTopics)
    getHelpContent()
      .then(result => {
        if (!result.items) return false;
        const categories = (result.items.map((category: any): any => category.fields));
        categories.forEach((category: any): any => {
          category.topics = category.topics.map((topic: any): any => topic.fields);

        })
        setCoachHelpCategories(categories);
      });
  }, []);

  useEffect(() => {
    //contentful.query(GetHelpCategoriesAndTopics)
    getHelpContent()
      .then(result => {
        if (!result.items) return false;
        const categories = (result.items.map((category: any): any => category.fields));
        categories.forEach((category: any): any => {
          category.topics = category.topics.map((topic: any): any => topic.fields);

        })

        setClientHelpCategories(categories);
      });
  }, []);

  useEffect(() => {
    //console.log('clientHelpCategories');
    //console.log(clientHelpCategories);
  }, [clientHelpCategories])

  return (
    <BasicLayout showBackgroundImage backPath="/">
      <Container maxW="1080px" minH="100vh" px={[4, 12]} centerContent>
        <VStack spacing={8} width="100%">
          <Box w="200px" mt={24}>
            <Logo />
          </Box>
          <Heading size="lg" textAlign="center">
            Help & FAQs
          </Heading>
          <Tabs>
            <TabList>
              <Tab>Coach</Tab>
              <Tab>Client</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <SimpleGrid
                  columns={{ sm: 1 }}
                  templateColumns={{ sm: "1fr", md: "auto 1fr" }}
                  bgColor="gray.700"
                  rounded={8}
                  color="white"
                  width="100%"
                  minChildWidth="120px"
                  minH={{ md: "xl" }}
                  boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
                >
                  <Categories
                    categories={coachHelpCategories}
                    callback={setCoachActiveIndex}
                    activeIndex={coachActiveIndex}
                  />
                  <Section topics={coachTopics} />
                </SimpleGrid>
              </TabPanel>
              <TabPanel>
                <SimpleGrid
                  columns={{ sm: 1 }}
                  templateColumns={{ sm: "1fr", md: "auto 1fr" }}
                  bgColor="gray.700"
                  rounded={8}
                  color="white"
                  width="100%"
                  minChildWidth="120px"
                  minH={{ md: "xl" }}
                  boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
                >
                  <Categories
                    categories={clientHelpCategories}
                    callback={setClientActiveIndex}
                    activeIndex={clientActiveIndex}
                  />
                  <Section topics={clientTopics} />
                </SimpleGrid>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </VStack>
      </Container>
    </BasicLayout>
  );
};

export default Help;
